export default "__VITE_ASSET__mFZk22Pi__"